"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function _dataValue(data, path, pindex, schema) {
    var prop = path[pindex];
    if (prop === '') {
        if (pindex === path.length - 1) {
            return undefined;
        }
        else {
            return _dataValue(data, path, pindex + 1, schema);
        }
    }
    if (schema) {
        if (schema.type === 'object' && schema.properties) {
            var schitem = schema.properties[prop];
            if (schitem === undefined) {
                return undefined;
            }
            var ndata = data[prop];
            if (ndata === undefined) {
                if (schitem.default !== undefined) {
                    ndata = schitem.default;
                }
                else {
                    return undefined;
                }
            }
            if (pindex === path.length - 1) {
                return ndata;
            }
            else {
                return _dataValue(ndata, path, pindex + 1, schitem);
            }
        }
        else if (schema.type === 'array') {
            var schitem = schema.items;
            if (schitem === undefined) {
                return undefined;
            }
            var ndata = data[Number(prop)];
            if (ndata === undefined) {
                if (schitem.default !== undefined) {
                    ndata = schitem.default;
                }
                else {
                    return undefined;
                }
            }
            if (pindex === path.length - 1) {
                return ndata;
            }
            else {
                return _dataValue(ndata, path, pindex + 1, schitem);
            }
        }
        else {
            return undefined;
        }
    }
}
function dataValue(schema, data, path) {
    var tpath = path
        .replace(/\[/g, '.')
        .replace(/\]/g, '')
        .split('.');
    return _dataValue(data, tpath, 0, schema);
}
exports.default = dataValue;
//# sourceMappingURL=dataValue.js.map